import styled from 'styled-components';

const FooterWrapper = styled.div`
  .footer {
    padding-bottom: 25px;
    border-top: 1px solid #e5e5e5;
  }

  .footer .footer-logo {
    margin-top: 25px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-content: center;

    img {
      max-height: 100px;
      max-width: 200px;
    }
  }

  .copyright-block {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .copyright {
      margin-right: 20px;
      color: #7e7e7e;
    }

    .socials-block {
      display: flex;
      justify-content: end;

      a {
        padding: 0 5px;
      }
    }
  }

  .footer .page-policy-block p {
    margin-bottom: 0;
    margin-left: 30px;
    //margin-bottom: 20px;
  }

  .footer .page-policy-block {
    display: flex;
    align-items: center;
  }

  .footer .logo-block {
    display: flex;
    align-items: center;
  }

  .footer .logo-block p {
    margin-right: 20px;
    color: #7e7e7e;
  }

  .footer .logo-block .resto-footer-img {
    width: 170px;
  }

  .footer .page-policy-block p .policy-link {
    font-weight: 400;
    font-size: 13px;
    line-height: 28px;
    color: #7e7e7e;
  }

  .footer .page-policy-block .copyright {
    font-weight: 400;
    font-size: 13px;
    color: #7e7e7e;
    margin-top: 10px;
    margin-bottom: 0;
    //text-align: center;
  }

  @media (max-width: 768px) {
    .footer .footer-logo {
      display: inline-block;
    }

    .footer .page-policy-block {
      p:first-child {
        margin-left: 0;
      }
      margin-top: 15px;
      margin-bottom: 30px;
    }
    .copyright-block {
      align-items: baseline;
    }
  }
`;

export default FooterWrapper;
